import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../../commonComponents/translate';
import TrophyConfigProp from '../../propTypes/trophyConfigProp';

function TrophyDisplay({ t, trophy, onSelect }) {
  const trophyContainer = stat => cx({ 'trophy-enabled': !!stat });

  return (
    <div className="profile-trophy col-lg-2 col-4">
      <a onClick={onSelect} className={trophyContainer(trophy.stats)}>
        <div className="trophy-name">{t(trophy.translationKey)}</div>
        <img alt="trophy" className="trophy-icon" src={trophy.imageURL} />
        <div className="trophy-number">
          {trophy.stats ? `${trophy.stats.total}x` : '0x'}
        </div>
      </a>
    </div>
  );
}

TrophyDisplay.propTypes = {
  t: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  trophy: PropTypes.shape(TrophyConfigProp.propType).isRequired,
};

export default translate(TrophyDisplay);
